/**
 * @deprecated Compatibility shim — Domain was renamed to Application.
 * This module path stays because it is federated (vite.config.ts exposes)
 * and registered under the `adminDomainService` service key.
 */
export { AdminApplicationService, AdminDomainService } from './AdminApplicationService';
